import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=d882dccc&scoped=true&lang=pug&"
import script from "./ChatMessage.vue?vue&type=script&lang=js&"
export * from "./ChatMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=d882dccc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d882dccc",
  null
  
)

export default component.exports